/**
 * Application-wide constants
 * Centralized location for magic numbers and configuration values
 */

// Authentication & Token Management
export const TOKEN_EXPIRY_THRESHOLD_SECONDS = 180; // 3 minutes
export const TOKEN_REFRESH_CHECK_INTERVAL_MS = 60000; // 1 minute

// Video Progress Tracking
export const VIDEO_PROGRESS_CHECK_INTERVAL_MS = 2000; // 2 seconds
export const VIDEO_PROGRESS_TRACK_THRESHOLD_SECONDS = 10; // Track every 10 seconds of playback
export const VIDEO_COMPLETION_THRESHOLD = 0.90; // 90% completion threshold
export const VIDEO_COMPLETION_DELAY_MS = 100; // Delay before marking complete

// Query & Pagination
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_SEARCH_DELAY_MS = 500;
export const QUERY_STALE_TIME_MS = 3600000; // 1 hour
export const QUERY_GC_TIME_MS = 3600000; // 1 hour

// SignalR Reconnection
export const SIGNALR_MAX_RETRY_DELAY_MS = 30000; // 30 seconds
export const SIGNALR_RETRY_TIMEOUT_MS = 60000; // 1 minute

// Toast Notifications
export const TOAST_REMOVE_DELAY_MS = 1000000; // Time before toast is removed

// File Upload
export const MAX_FILE_SIZE_MB = 100;
export const UPLOAD_PROGRESS_UPDATE_THRESHOLD = 95; // Don't show 100% until complete

// Cache & Storage
export const CACHE_MAX_AGE_SECONDS = 3600; // 1 hour

// UI Debouncing
export const DEBOUNCE_DELAY_MS = 500;

// Form Validation
export const MAX_TITLE_LENGTH = 255;
export const MAX_FILENAME_LENGTH = 255;
export const MAX_SEARCH_QUERY_LENGTH = 200;

// Retry Configuration
export const MAX_RETRY_ATTEMPTS = 3;
export const MAX_MUTATION_RETRY_ATTEMPTS = 2;

